import React,{Component} from 'react';
import { Widget, addResponseMessage, addLinkSnippet, addUserMessage,deleteMessages } from 'react-chat-widget';

import 'react-chat-widget/lib/styles.css';

import './reactchatwidget.css'

import {socket} from "../utils/socket"


const logo="https://www.piyanos.com/logo/logo300.png"//__dirname+"/assets/logo.svg"
const logoWhite500="https://www.piyanos.com/logo/logo-white500.png"


class ReactChatWidget extends Component{
    constructor(props){
        super(props);
        this.state={
            subtitle:"AkıllıBETA",
            dev:true
        }
    }

    componentDidMount=()=>{
        this.socketOp()

        /*
        let messageId = new Date().toLocaleDateString()
        addResponseMessage("deneme",messageId)
        setTimeout(()=>{
            deleteMessages(1)
            addResponseMessage("dsfdsfdsrfds")
        },4000)

        let linkSnipped={
            title: 'Detaylar için web sitemizi ziyaret edebilirsiniz',
            link: 'https://piyanos.com',
            target: '_blank'
          }
        addLinkSnippet(linkSnipped)
        */

    }


    socketOp=()=>{
        socket.on("piyancleverbot-message",(arg)=>{
            console.log("piyancleverbot-message",arg)
            if(arg.message){
                addResponseMessage(arg.message)
            }
        })
    }

     handleNewUserMessage = (newMessage) => {
        console.log(`New message incoming! ${newMessage}`);
        socket.emit("piyancleverbot-message",{message:newMessage})
      };



    render(){
        const {subtitle} = this.state
        return(
            <div>
                {
                    !this.state.dev
                    &&
                    <Widget
                    //  autofocus={true}
                      chatId="rcw-chat-container"
                      titleAvatar={logoWhite500}
                         senderPlaceHolder="mesajınızı buraya yazın.."
                         handleNewUserMessage={(e)=>this.handleNewUserMessage(e)}
                         profileAvatar={logo}
                         title="PiyanBOT"
                         subtitle={subtitle}
                    />
                }
            </div>
        )
    }
}


export default ReactChatWidget;